import { cn } from '@/context/global/utils/cn';

export type IconPlayProps = {
  className?: string;
  size?: number;
};

export default function IconPlay({ className = '', size = 32 }: IconPlayProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M5.33398 16V11.2534C5.33398 5.36002 9.50732 2.94669 14.614 5.89336L18.734 8.26669L22.854 10.64C27.9607 13.5867 27.9607 18.4134 22.854 21.36L18.734 23.7334L14.614 26.1067C9.50732 29.0534 5.33398 26.64 5.33398 20.7467V16Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
